import ReactGA from 'react-ga4';

// Initialize GA4
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
  if (measurementId) {
    ReactGA.initialize(measurementId);
  }
};

// Track page views
export const trackPageView = (path) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

// Track events
export const trackEvent = (category, action, label) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    });
  }
};

// Track user sign up
export const trackSignUp = (method) => {
  trackEvent('User', 'Sign Up', method);
};

// Track purchase
export const trackPurchase = (plan, amount) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    trackEvent('Purchase', 'Complete', plan);
    ReactGA.event({
      category: 'Purchase',
      action: 'Complete',
      label: plan,
      value: amount,
      currency: 'AUD'
    });
  }
};

// Track slideshow creation
export const trackSlideshowCreation = (imageCount) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    trackEvent('Slideshow', 'Create', `Images: ${imageCount}`);
  }
}; 